export default __webpack_public_path__ + "static/media/Group8863.43b37e73.svg";